import { useTranslation } from 'react-i18next'

import { Link } from 'react-router-dom'

import { useAppSettings } from '@/stores/useAppSettings'

import { paths } from '@/config/paths'

import { useIsMobile } from '@/hooks/use-mobile'

interface AppLogoProps {
  useMobileLogo?: boolean
}

export function AppLogo({ useMobileLogo = false }: AppLogoProps) {
  const { t } = useTranslation(['common', 'auth'])
  const { getSetting } = useAppSettings()
  const isMobile = useIsMobile()

  const logoSetting = getSetting('branding.app_logo_url')
  const mobileLogoSetting = getSetting('branding.mobile_logo_url')

  // Use mobile logo if: explicitly requested OR on mobile device AND mobile logo exists
  const shouldUseMobileLogo =
    (useMobileLogo || isMobile) &&
    mobileLogoSetting &&
    typeof mobileLogoSetting === 'string' &&
    mobileLogoSetting.trim()

  const appLogo = shouldUseMobileLogo
    ? mobileLogoSetting
    : typeof logoSetting === 'string' && logoSetting.trim()
      ? logoSetting
      : '/barbella_logo.png' // Fallback to public asset

  const appNameSetting = getSetting('general.app_name')
  const appName = typeof appNameSetting === 'string' && appNameSetting.trim() ? appNameSetting : 'Barbella Gym'

  return (
    <Link to={paths.public.home.getHref()}>
      <img
        src={appLogo}
        alt={t('auth:appLogo.alt', { defaultValue: `${appName} Logo`, appName })}
        className='max-h-10 w-auto object-contain'
        loading='lazy'
      />
    </Link>
  )
}
